/**
 * Okta configuration for was-web.
 * Values are read from REACT_APP_OKTA_* env vars (see .env.development).
 */
import type { OktaAuthOptions } from '@okta/okta-auth-js';

import { config as appConfig } from '../app-config';

const defaultRedirectUri = (): string =>
    typeof window !== 'undefined' ? `${window.location.origin}/login/callback` : '/login/callback';

export const oktaConfig: OktaAuthOptions = {
    issuer: appConfig.okta.issuer,
    clientId: appConfig.okta.clientId,
    redirectUri: appConfig.okta.redirectUri || defaultRedirectUri(),
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    tokenManager: {
        // Okta is used only to sign in. Keep its tokens in sessionStorage (never
        // localStorage) so nothing token-related persists after the tab closes,
        // and disable autoRenew so Okta never silently calls /v1/token.
        autoRenew: false,
    },
};
